const normalizeString = value =>
  (value || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

const parseTripDate = dateStr => {
  if (!dateStr) return null;
  let candidate = dateStr;
  if (dateStr.includes(',')) {
    candidate = dateStr.split(',').pop().trim();
  }

  const parsed = new Date(candidate);
  if (!Number.isNaN(parsed?.getTime())) {
    parsed.setHours(0, 0, 0, 0);
    return parsed;
  }

  const parts = candidate.split('/');
  if (parts.length === 3) {
    const [month, day, year] = parts.map(Number);
    const fallback = new Date(year, month - 1, day);
    if (!Number.isNaN(fallback.getTime())) {
      fallback.setHours(0, 0, 0, 0);
      return fallback;
    }
  }

  return null;
};

const locationMatches = (fields, search) => {
  const normalizedSearch = normalizeString(search);
  if (!normalizedSearch) return true;
  return fields.some(field => {
    const normalizedField = normalizeString(field);
    if (!normalizedField) return false;
    return (
      normalizedField.includes(normalizedSearch) ||
      normalizedSearch.includes(normalizedField)
    );
  });
};

export const matchesSearchFilters = (trip, filters = {}) => {
  if (!trip) return false;
  const originFields = [
    trip.originCity,
    trip.originCountry,
    trip.originDetails?.city,
    trip.originDetails?.country,
  ];
  const destinationFields = [
    trip.destinationCity,
    trip.destinationCountry,
    trip.destinationDetails?.city,
    trip.destinationDetails?.country,
  ];

  if (
    filters.from?.description &&
    !locationMatches(originFields, filters.from.description)
  ) {
    return false;
  }

  if (
    filters.to?.description &&
    !locationMatches(destinationFields, filters.to.description)
  ) {
    return false;
  }

  if (filters.departureDate) {
    const tripDate = parseTripDate(trip.departureDate);
    const filterDate = new Date(filters.departureDate);
    if (!Number.isNaN(filterDate.getTime())) {
      filterDate.setHours(0, 0, 0, 0);
      if (!tripDate || tripDate.getTime() !== filterDate.getTime()) {
        return false;
      }
    }
  }

  return true;
};


